export const IMAGE_CONTROLLER = (activeIndex) => (dispatch) => {
  dispatch({ type: 'IMAGE_CONTROLLER', activeIndex });
};

export const RERENDER_GALLERY = (status) => (dispatch) => {
  dispatch({ type: 'RERENDER_GALLERY', status });
};

export const REGISTER_SLIDER = (sliderType, sliderEl) => {
  return {
    type: 'REGISTER_SLIDER',
    sliderType,
    sliderEl,
  };
};
